import { Action } from 'corso-admin-ui';
import { CrewClaimResolutionMethodEnum } from 'corso-types';
import { ResolutionModifierProps } from './types';

export default function RepairModifier({
  onCancel,
  onSave,
}: ResolutionModifierProps<typeof CrewClaimResolutionMethodEnum.repair>) {
  return (
    <div className="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
      <Action variant="ghost" onClick={onCancel}>
        Cancel
      </Action>
      <Action
        variant="primary"
        onClick={() => {
          onSave({
            resolutionMethod: CrewClaimResolutionMethodEnum.repair,
          });
        }}
      >
        Save
      </Action>
    </div>
  );
}
